
let _this,searchParams= {
  sortName: "createTime",
  sortType: 1,
  page: 1,
  perPage: 10,
  isRecurringReport: true,
  enabledPaging:true
};
export default {
  data() {
    _this = this;
    return {
      titleData:[
        {title: 'Report Name', key: 'reportName', minWidth: 200,
          render: (h, params) => {
            return h('utm-ellipsis', {
              props: {
                content: params.row['reportName'],
                transfer: true
              }
            })
          }
        },
        {title: 'Time Period', slot: 'period', minWidth: 260},
        {title: 'Generated Time', slot: 'createTime', minWidth: 200, sortable: 'custom', sortType: 'desc'},
        {title: 'Status', slot: 'status', minWidth: 150},
        {title: 'Operation', slot: 'operation', minWidth: 200, fixed: 'right'}
      ],
      searchParams: JSON.parse(JSON.stringify(searchParams)),
      tableData: [],
      generateStatus:{'0':'Generating', '1':'Generated', '2':'Failed', '3':'Abnormal'},
      timePeriodStatus: [
        {value: 0, label: 'Daily'},
        {value: 1, label: 'Weekly'},
        {value: 2, label: 'Monthly'},
        {value: 3, label: 'HalfYearly'},
        {value: 4, label: 'Yearly'}
      ],
      isTableLoading:true,
    }
  },
  mounted() {
    _this = this;
    _this.getTableData();
  },
  methods: {
    //获取列表
    getTableData: function () {
      _this.$set(_this,'tableData',[]);
      _this.isTableLoading = true;
      this.$ajax.post('GenerateReport/Paging',_this.searchParams,{headers: {noLoading: true}}).then(function (res) {
        if (res.data.success) {
          _this.tableData = res.data.data.items;
          _this.tableData.forEach(item=>{
            _this.$set(item,'isLoading',false);
          })
        } else {
          _this.$set(_this,'tableData',[]);
        }
        _this.isTableLoading = false;
      })
    },
    // 列表排序
    sortTable: function (data) {
      this.shareApi.sortTable(this, data, this.getTableData);
    },
    downLoad:function(row,type){
      _this.tableData.forEach(item=>{
        if(row.id === item.id){
          _this.$set(item,'isLoading',true)
        }
      })
      let subData =  {
        name:row.reportName,
        id:row.id,
        includeAttachment:row.includeAttachment,
        needEncrypt: false,
        includeVideo:row.exportVideo,
        formats: [type],
        reportFormat : type,
        password:''
      }
      this.$ajax.post('GenerateReport/Download',subData,{headers: {noLoading: true},responseType:"blob"}).then(function (res) {
        let blob = res.data;
        let a = document.createElement("a");
        a.download = row.reportName + "_"+ new Date().getTime() + ".zip";
        a.style.display = "none";
        a.href= window.URL.createObjectURL(blob);
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        _this.tableData.forEach(item=>{
          if(row.id === item.id){
            _this.$set(item,'isLoading',false);
          }
        })
        _this.downloadModal = false;
      })
    },
  },
}



// WEBPACK FOOTER //
// ./src/admin/components/downloadCenters/recurring.js